<mic-breadcrumb class="mb-0">
  <mic-breadcrumb-link link="/home/dashboard" icon="home" ariaLabel="Home"></mic-breadcrumb-link>
  <mic-breadcrumb-link link="/work-orders" label="{{ translationService.translate('workOrdersText') }}"></mic-breadcrumb-link>
</mic-breadcrumb>

<h3 class="mt-1">{{ translationService.translate('workOrdersText') }}</h3>

<div class="flex flex-row justify-between align-items-center mb-3">
  <span class="responsive-flex">
    <mat-card>
      <mat-card-content class="mt-2">
        <form [formGroup]="workOrderFilterForm">
          <div class="filter-container" style="display: flex; align-items: flex-start; gap: 16px">
            <mat-form-field appearance="fill" class="filter-item">
              <mat-label title="{{ translationService.translate('searchByWorkOrdersText') }}">{{
                translationService.translate('searchByWorkOrdersText')
              }}</mat-label>
              <input
                id="workOrderNumberInput"
                matInput
                formControlName="workOrderNumber"
                placeholder="{{ translationService.translate('enterWorkOrderNumText') }}"
                title="{{ translationService.translate('enterWorkOrderNumText') }}"
              />
              <button id="search-work-order-num" disabled mat-icon-button matSuffix>
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>
            <div class="filter-item" title="{{ translationService.translate('searchByWorkOrderStatusText') }}">
              <mic-dropdown-search
                micDropdownAccessibility
                id="workOrderStatusInput"
                formControlName="workOrderStatus"
                [data]="workOrderStatusList"
                [widthConfig]="{ width: '100%' }"
                placeholder="{{ translationService.translate('selectWorkOrderStatusText') }}"
                label="{{ translationService.translate('searchByWorkOrderStatusText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [multiple]="true"
                allLabel="{{ translationService.translate('allStatusText') }}"
                [attribute]="'displayName'"
              >
              </mic-dropdown-search>
            </div>
            <div class="filter-item" title="{{ translationService.translate('searchByPlantText') }}">
              <mic-dropdown-search
                micDropdownAccessibility
                id="workOrderPlantInput"
                formControlName="workOrderPlant"
                [data]="plantList"
                [widthConfig]="{ width: '100%' }"
                placeholder="{{ translationService.translate('selectPlantText') }}"
                label="{{ translationService.translate('searchByPlantText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [multiple]="true"
                [attribute]="'displayName'"
                allLabel="{{ translationService.translate('allText') }}"
                [compareWith]="compareById"
              >
              </mic-dropdown-search>
            </div>
            <div class="filter-item" title="{{ translationService.translate('searchBySiteText') }}">
              <mic-dropdown-search
                micDropdownAccessibility
                id="workOrderSiteInput"
                formControlName="workOrderSite"
                [data]="siteList"
                [widthConfig]="{ width: '100%' }"
                placeholder="{{ translationService.translate('selectSiteText') }}"
                label="{{ translationService.translate('searchBySiteText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [attribute]="'displayName'"
                [multiple]="true"
                allLabel="{{ translationService.translate('allStatusText') }}"
                [compareWith]="compareById"
              >
              </mic-dropdown-search>
            </div>
            <div class="button-container-1">
              <button
                id="clear-selection-button"
                type="button"
                mat-flat-button
                color="accent"
                (click)="clearSelections()"
                style="margin-right: 25px"
                class="wo-buttons"
              >
                <mat-icon>refresh</mat-icon> {{ translationService.translate('clearSelectionText') }}
              </button>
              @if (isCreateWorkOrderEnabled && canCreateWorkOrders()) {
              <button
                id="create-new-wo-button"
                type="button"
                mat-flat-button
                color="primary"
                class="wo-buttons"
                (click)="navigateToCreateWorkOrder()"
              >
                <mat-icon>add</mat-icon> {{ translationService.translate('createNewWoText') }}
              </button>
              }
              <button mat-flat-button color="primary" (click)="openExportModal()" class="wo-buttons" style="margin-left: 25px">
                <mat-icon>file_download</mat-icon>{{ translationService.translate('exportText') }}
              </button>
            </div>
          </div>
          <div class="filter-container" style="display: flex; align-items: flex-start; gap: 16px">
            <mat-form-field appearance="fill" class="filter-item">
              <mat-label title="{{ translationService.translate('searchByReceivedDateText') }}">{{
                translationService.translate('searchByReceivedDateText')
              }}</mat-label>
              <mat-date-range-input [rangePicker]="rangePicker">
                <input
                  id="workOrderReceivedDateStartInput"
                  matStartDate
                  title="{{ translationService.translate('selectReceivedText') }} {{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="workOrderReceivedDateStart"
                />
                <input
                  id="workOrderReceivedDateEndInput"
                  matEndDate
                  title="{{ translationService.translate('selectReceivedText') }} {{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="workOrderReceivedDateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #rangePicker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field appearance="fill" class="filter-item">
              <mat-label title="{{ translationService.translate('searchByDueDateText') }}">{{
                translationService.translate('searchByDueDateText')
              }}</mat-label>
              <mat-date-range-input [rangePicker]="dueDatePicker">
                <input
                  id="workOrderDueDateStartInput"
                  matStartDate
                  title="{{ translationService.translate('selectDueText') }} {{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="workOrderDueDateStart"
                />
                <input
                  id="workOrderDueDateEndInput"
                  matEndDate
                  title="{{ translationService.translate('selectDueText') }} {{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="workOrderDueDateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #dueDatePicker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" class="filter-item">
              <mat-label title="{{ translationService.translate('CRNText') }}">{{ translationService.translate('CRNText') }}</mat-label>
              <input
                id="crnInput"
                matInput
                type="text"
                formControlName="crn"
                placeholder="{{ translationService.translate('CRNText') }}"
                title="{{ translationService.translate('CRNText') }}"
              />
            </mat-form-field>

            <!-- moved customer search items into this (previous) row -->
            <mat-form-field subscriptSizing="dynamic" class="filter-item">
              <mat-label title="{{ translationService.translate('customerCodeText') }}">{{
                translationService.translate('customerCodeText')
              }}</mat-label>
              <input
                id="customerCodeInput"
                matInput
                type="text"
                formControlName="customerCode"
                title="{{ translationService.translate('customerCodeText') }}"
              />
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic" class="filter-item">
              <mat-label title="{{ translationService.translate('customerNameText') }}">{{
                translationService.translate('customerNameText')
              }}</mat-label>
              <input
                id="customerNameInput"
                matInput
                type="text"
                formControlName="customerName"
                title="{{ translationService.translate('customerNameText') }}"
              />
            </mat-form-field>
            <button
              id="searchCustomerInput"
              mat-flat-button
              class="mic-btn-icon-left"
              style="height: 56px"
              (click)="openCustomerModal()"
              type="button"
            >
              <mat-icon>search</mat-icon>
              <span>{{ translationService.translate('searchCustomerText') }}</span>
            </button>
          </div>
        </form>
        <mic-table appCopyOnSelect id="workOrderTable" class="table-stripped cam-table" [config]="tableConfig" [fetcher]="fetcher">
          <ng-container *micTableColumnSelector>
            <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
              <mat-icon>view_column</mat-icon>{{ translationService.translate('columnsButtonText') }}
            </button>
            <mat-menu #colMenu="matMenu">
              <div style="padding: 8px 16px; max-width: 320px">
                <div *ngFor="let key of columnKeys">
                  <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">{{
                    columnNames[key] || key
                  }}</mat-checkbox>
                </div>
              </div>
            </mat-menu>
          </ng-container>
          <ng-container *micCellTemplate="let item; name: 'numberOfLinesCell'">
            <span [matTooltip]="translationService.translate('numLinesHoverText')" matTooltipPosition="above">
              {{
                dealer.displayDeleteCasing === 'N' && isDeleteWorkOrderEnabled
                  ? (item.numberOfLines || 0) - (item.deletedCasingCount || 0)
                  : item.numberOfLines || 0
              }}
            </span>
          </ng-container>
          <ng-container *micCellTemplate="let item; name: 'workOrderStatusCell'">
            <mic-status [class]="getStatusClass(item.workOrderStatus)" [matTooltip]="getStatusTooltip(item.workOrderStatus)">
              {{ getStatusLabel(item.workOrderStatus) }}
            </mic-status>
          </ng-container>

          <ng-container *micCellTemplate="let item; name: 'actionCell'">
            <mat-icon class="delete-icon-only" (click)="deleteWorkOrder(null)">delete</mat-icon>
          </ng-container>
          <ng-container *micTableNoData>
            <mic-empty-state icon="layers_clear" title="{{ translationService.translate('noDataDisplayText') }}"> </mic-empty-state>
          </ng-container>
          <ng-container *micTableRowMenu="let item">
            @if (isDeleteWorkOrderEnabled) {
            <span
              [matTooltip]="
                !isWorkOrderDeletable(item) || !enableWorkOrderDelete() ? translationService.translate('notEligibleToDeleteText') : ''
              "
              [matTooltipDisabled]="isWorkOrderDeletable(item) && enableWorkOrderDelete()"
              matTooltipPosition="above"
            >
              <button
                id="delete-work-order-line"
                type="button"
                (click)="onDeleteClick(item)"
                [disabled]="!isWorkOrderDeletable(item) || !enableWorkOrderDelete()"
                mat-menu-item
              >
                <mat-icon class="delete-icon-only">delete</mat-icon> {{ translationService.translate('deleteText') }}
              </button>
            </span>
            }
          </ng-container>
        </mic-table>
      </mat-card-content>
    </mat-card>
  </span>
</div>
<mic-modal #customerModal></mic-modal>
<ng-template #customerModalContent>
  <mic-customer-select-model
    [dealerId]="dealer?.id"
    [activeOnly]="true"
    [userLogin]="userLogin"
    [plantId]="plantId"
    (result)="onCustomerSelected($event)"
  >
  </mic-customer-select-model>
</ng-template>
